import { Autocomplete, TextField, Box, Button, Collapse } from "@mui/material";
import { useState } from "react";
import { EntraUser } from "../../../../../services/profileService/model/entraUser/EntraUser";
import { useUserSearchQuery } from "../../../../../services/profileService/profile-api";
import { ManualUserEntry } from "../components/ManualUserEntry";

type UARUserSelectorProps = {
  value: string;
  updateFunc: (value: EntraUser) => void;
};

function UARUserSelector(props: UARUserSelectorProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const { data } = useUserSearchQuery(searchTerm, { skip: searchTerm.length < 3 });
  const users = [...(data ?? [])];
  const [selectedUser, setSelectedUser] = useState<EntraUser | null>(null);
  const [isManualEntry, setIsManualEntry] = useState(false);
  const [manualUser, setManualUser] = useState(new EntraUser());

  const handleUserChange = (user: EntraUser | null) => {
    setSelectedUser(user);
    props.updateFunc(user || new EntraUser());
  };

  const toggleManualEntry = () => {
    setIsManualEntry(!isManualEntry);
    if (!isManualEntry) {
      // Reset the selected user from search when switching to manual entry
      setSelectedUser(null);
    }
  };

  const handleManualUserChange = (user: EntraUser) => {
    setManualUser(user);
    props.updateFunc(user);
  };

  return (
    <Box>
      {!isManualEntry ? (
        <>
          <Autocomplete
            options={users}
            getOptionLabel={(user) => user.displayName}
            value={selectedUser}
            onInputChange={(e, value) => setSearchTerm(value)}
            onChange={(e, value) => handleUserChange(value)}
            renderInput={(params) => <TextField {...params} variant="outlined" />}
            noOptionsText="no users"
            disabled={isManualEntry}
          />
          <Box sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <Button 
              size="small" 
              onClick={toggleManualEntry}
              color="primary"
            >
              Enter User Manually
            </Button>
          </Box>
        </>
      ) : (
        <>
          <ManualUserEntry 
            user={manualUser}
            onChange={handleManualUserChange}
            onCancel={() => {
              setIsManualEntry(false);
              if (!selectedUser) {
                props.updateFunc(new EntraUser());
              }
            }}
          />
        </>
      )}
    </Box>
  );
}

export { UARUserSelector };
